<div class="registration">
  <maintenance-mode-banner></maintenance-mode-banner>
  <p-steps
    [activeIndex]="activeStep"
    [model]="stepsItems"
    [readonly]="false"
    (activeIndexChange)="onStepChange($event)"
    styleClass="stepper"
  />

  <div class="registration-content">
    <!-- Info Card -->
    <p-card
      header="{{
        'CARRIERDB.DEAR_REPRESENTATIVE' | translate : locale.language
      }}"
      class="content-card"
      *ngIf="activeStep === 0"
    >
      <supplierDB-registration-registration-info />
      <ng-template pTemplate="footer">
        <div class="flex gap-3 mt-1">
          <p-button
            label="{{ 'GENERAL.PROCEED' | translate : locale.language }}"
            class="w-full"
            styleClass="w-full"
            (onClick)="onNextStep()"
          />
        </div>
      </ng-template>
    </p-card>

    <!-- General Company Info Form -->
    <p-card
      header="{{ 'CARRIERDB.COMPANY_CONTACT' | translate : locale.language }}"
      class="content-card"
      *ngIf="activeStep === 1"
    >
      <supplierDB-registration-registration-contact #registrationContact />
      <ng-template pTemplate="footer">
        <div class="flex gap-3 mt-1">
          <p-button
            label="{{ 'GENERAL.BACK' | translate : locale.language }}"
            severity="secondary"
            class="w-full"
            styleClass="w-full"
            (onClick)="onPreviousStep()"
          />
          <p-button
            label="{{ 'GENERAL.PROCEED' | translate : locale.language }}"
            class="w-full"
            styleClass="w-full"
            pTooltip="{{'CARRIERDB.COMPANY_CONTACT_MISSING_INFORMATION_TT' | translate:locale.language}}"
            [tooltipDisabled]="registrationContact.isFormValid()"
            [disabled]="!registrationContact.isFormValid()"
            (onClick)="onNextStep(); getContactData()"
          />
        </div>
      </ng-template>
    </p-card>

    <!-- Company Selection Form -->
    <p-card
      header="{{ 'CARRIERDB.COMPANY_DETAILS' | translate : locale.language }}"
      class="content-card"
      *ngIf="activeStep === 2"
    >
      <supplierDB-registration-registration-selection #registrationSelection />
      <ng-template pTemplate="footer">
        <div class="flex gap-3 mt-1">
          <p-button
            label="{{ 'GENERAL.BACK' | translate : locale.language }}"
            severity="secondary"
            class="w-full"
            styleClass="w-full"
            (onClick)="onPreviousStep()"
          />
          <p-button
            label="{{ 'GENERAL.PROCEED' | translate : locale.language }}"
            class="w-full"
            styleClass="w-full"
            [disabled]="!registrationSelection.hasOneRegionSelection() || !registrationSelection.hasOneSegmentSelection()"
            pTooltip="{{'CARRIERDB.COMPANY_DETAILS_MISSING_SELECTION_TT' | translate:locale.language}}"
            [tooltipDisabled]="registrationSelection.hasOneRegionSelection() && registrationSelection.hasOneSegmentSelection()"
            (onClick)="onNextStep(); selectionDataValid = true"
          />
        </div>
      </ng-template>
    </p-card>

    <!-- Overview Card -->
    <p-card
      header="{{ 'CARRIERDB.OVERVIEW' | translate : locale.language }}"
      class="content-card"
      *ngIf="activeStep === 3"
    >
      <supplierDB-registration-registration-overview />
      <ng-template pTemplate="footer">
        <div class="flex gap-3 mt-1">
          <p-button
            label="{{ 'GENERAL.BACK' | translate : locale.language }}"
            severity="secondary"
            class="w-full"
            styleClass="w-full"
            (onClick)="onPreviousStep()"
          />
          <p-button
            label="{{ 'GENERAL.SUBMIT' | translate : locale.language }}"
            class="w-full"
            styleClass="w-full"
            (onClick)="onSubmit()"
          />
        </div>
      </ng-template>
    </p-card>
  </div>
</div>
